module.exports = __webpack_public_path__ + "static/media/12_2.a6f50b48.png";